// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__229Kr","clinicsSelect":"TableHeading_clinicsSelect__1BOCl"};